enum Scales {
    SHORT = 'short',
    LONG = 'long',
}

export default Scales
